<template>
  <div class="newsDetail_box">
    <div class="bigBox">

      <!-- 面包屑 -->
      <div class="breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumbColor">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:'/discover'}">聆听观止</el-breadcrumb-item>
          <el-breadcrumb-item>{{conList.str_program_title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 内容区域 -->
      <div class="detailCon_box" >
        <div class="detail_con">
          <h1>{{conList.str_program_title}} | 第{{conList.id}}期</h1>
          <div class="img">
            <div class="bgImgBox">
              <img :src="conList.str_img_url" alt="" class="bgimg"> 
              <h6 class="Photographer">{{conList.str_picture_enjoy}}</h6>  
            </div>
            <img src="../../../static/img/what_btn.png" alt="" class="btn" @click="playAudio()" id="btn">
            <audio :src="conList.str_audio_url"  id="myAudio"></audio>
          </div>
          
          <h2>{{conList.str_peam_title}}</h2>
          <p class="autor">作者：{{conList.str_autor_info}}</p>
          <p class="article" v-html="conList.str_peam_content"></p>
          <!-- 领读嘉宾 -->
          <div class="guest">
            <div class="leadingGuest" v-for="(item,index) in guestList" :key="index" id="guest">
              <img :src="item.url" alt="">
              <h3>{{item.name}}</h3>
              <p>{{item.title}}</p>
            </div>
          </div>
          <!-- 诗享 -->
          <div class="poetryEnjoyment">
            <h4>诗享</h4>
            <h5>Poetry Rview</h5>
            <div class="iconbox"><img src="../../../static/img/leaf_03.png" alt=""></div>
            <p class="article poetry_enjoy" v-html="conList.str_poetry_enjoy">{{conList.str_poetry_enjoy}}</p>
          </div>
          <!-- 图享 -->
          <div class="poetryEnjoyment">
            <h4>图享</h4>
            <h5>cover</h5>
            <div class="iconbox"><img src="../../../static/img/images/icon_03.png" alt=""></div>
            <p class="article poetry_enjoy" v-html="conList.str_picture_enjoy" style="text-align:center;"></p>
          </div>
          <!-- 乐享 -->
          <div class="poetryEnjoyment">
            <h4>乐享</h4>
            <h5>soundtrack</h5>
            <div class="iconbox"><img src="../../../static/img/images/icon_07.png" alt=""></div>
            <p class="article poetry_enjoy" v-html="conList.str_music_enjoy" style="text-align:center;"></p>
          </div>
          <!-- 二维码 -->
          <div class="QRcode"><img src="../../../static/img/thepoemforyou.jpg" alt=""></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import suspend from "../../../static/img/play_icon_03.png";
import begin from "../../../static/img/what_btn.png";
export default {
  data () {
    return {
      conList:'',
      listId:'',
      guestList:[],
      suspend:suspend,
      begin:begin
    }
  },
  created(){
    this.$parent.activeIndex = 'discover'
    this.wnlSliderLastFn(this.listId)
  },
  methods:{
    wnlSliderLastFn(id){
      this.listId = this.$route.query.id
      this.axios.post(
				process.env.API_HOST + '/programdetial',
				this.$qs.stringify({"id":this.listId})
			)
			.then( res => {
        this.conList = res.data.msg;
        this.guestList = res.data.msg.str_readpeam;
			})
			.catch(error => {
				this.$toast("网络错误，不能访问");
			})
    },
    playAudio(){
      var myAudio = document.getElementById("myAudio");
      var btn =document.getElementById("btn");
      if (myAudio.paused) {
        // 开始播放当前点击的音频
        myAudio.play();
        btn.src = suspend
      } else {
        myAudio.pause();
        btn.src = begin
      }
      myAudio.addEventListener('ended', function () {
        audioEnded();
      }, false);
      function audioEnded() {
          btn.src = begin
      }
    }
  }
}
</script>


<style scoped>
.newsDetail_box{
	display: inline-table;
  width: 100%;
  background: #fff;
}
.bigBox{
  width: 1140px;
  margin: 0 auto;
}
.breadcrumb_box {
  font-size: 20px;
  color: #666666;
  margin: 50px 0 80px;;
}
.breadcrumbColor{
  background: #fff !important;
}
.detailCon_box{
  width: 1000px;
  margin: 0 auto;
}
.detail_con h1{
  font-size: 44px;
  color: #333333;
  font-weight: 500;
  text-align: center;
  margin-bottom: 50px;
}

.detail_con .img{
  text-align: center;
  position: relative;
}
.img .bgImgBox{
  width: 650px;
  height: 450px;
  margin:  0 auto;
  /* position: relative; */
}
.img  .bgimg{
  width: 650px;
  max-height: 100%;
  /* height: auto; */
}
.Photographer{
  text-align: right;
  /* margin-right: 70px; */
  margin-top: 10px;
}
.detail_con .btn{
  width: 56px;
  height: 56px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top:-25px;
  margin-left:-25px;
}
.detail_con h2{
  text-align: center;
  font-size: 22px;
  margin-top: 68px;
}
.detail_con .autor{
  text-align: center;
  font-size: 16px;
  color: #aaaaac;
  margin-top: 20px;
}
.detail_con .article{
  text-align: center;
  font-size: 18px;
  line-height: 40px;
  color: #333333;
  margin-top: 35px;
  margin-bottom: 80px;  
}
.detail_con .leadingGuest,.poetryEnjoyment{
  text-align: center;
}
.leadingGuest img{
  border-radius: 50%;
  border: 6px solid #e5e5e5;
}
.leadingGuest h3{
  font-size: 18px;
  color: #545454;
  line-height: 60px;
}
.leadingGuest p{
  font-size: 14px;
  color: #838383;
  margin-bottom: 70px;
}
.guest{
  display: flex;
  justify-content: space-around;
  flex-wrap:wrap;
  margin:  0 auto;
}
.poetryEnjoyment h4{
  font-size: 22px;
  color: #333333;
  line-height: 60px;
  letter-spacing: 6px;
}
.poetryEnjoyment h5{
  font-size: 16px;
  color: #666666;
  line-height: 45px;
  letter-spacing: 2px;
}
.poetryEnjoyment .iconbox{
  width: 25px;
  height: 30px;
  margin: 15px auto;
}
.poetryEnjoyment img{
  width: 100%;
  height: 100%;
}
.poetryEnjoyment .poetry_enjoy{
  line-height: 45px;
  text-align: left;
}
.QRcode{
  text-align: center;
  margin-left: 425px;
  margin-bottom: 50px;
  width: 150px;
  height: 150px;
}
.QRcode img{
  width: 100%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/page/NewsDetail.vue